export type SharedPhotosView = 'loading' | 'password' | 'invalid' | 'error' | 'empty' | 'loaded'

export interface SharedPhotosInput {
  accessCalled: boolean
  accessLoading: boolean
  accessFailed: boolean
  access?: { success?: boolean; requiresPassword?: boolean } | null
  pwRequired: boolean
  photosCalled: boolean
  photosLoading: boolean
  photosFailed: boolean
  shared?: { photos?: unknown[] | null } | null
}

export function sharedPhotosView(i: SharedPhotosInput): SharedPhotosView {
  if (!i.accessLoading && i.accessFailed) return 'error'
  const opened = !!i.access?.success
  if (i.pwRequired && !opened) return 'password'
  if (!i.accessCalled || i.accessLoading) return 'loading'
  if (!i.access) return 'error'
  if (!opened) return 'invalid'
  if (!i.photosCalled || i.photosLoading) return 'loading'
  if (i.photosFailed) return 'error'
  if (!i.shared) return 'invalid'
  return (i.shared.photos || []).length ? 'loaded' : 'empty'
}
